import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { getKioskHomePath } from '../utils/kioskMode';

/**
 * Kiosk-only gate: renders children when `canAccess(permissions)` is true,
 * otherwise redirects to the user's allowed home webview.
 */
export function KioskWebViewAccessGate({ canAccess, children }) {
  const { isAuthenticated, permissions, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccess(permissions)) {
    return <Navigate to={getKioskHomePath(permissions)} replace />;
  }

  return children;
}

export default KioskWebViewAccessGate;
